import { MIN_NAME_LENGTH } from '@/features/profile-setting/constants/person';

const sharedDE = {
  'profile-edit': 'Profil bearbeiten',
  chats: 'Private Nachrichten',
  'my-posts': 'Meine Funks',
  participated: 'Mitgefunkt',
  'notification-setting': 'Benachrichtigungen & Kanäle',
  'app-setting': 'Darstellung & Sprache',
  'geo-area-subscription': 'Heimatort & Umkreis',
  help: 'Hilfe',
  'first-steps': 'Erste Schritte',
  'invite-friend': 'Freunde zur App einladen',
  legal: 'Rechtliche Informationen',
  'change-password': 'Passwort ändern',
  'request-data': 'Datenbericht anfordern',
  'delete-account': 'Konto löschen',
  experiments: 'Developer',
  'organization-overview': 'Organisationen',
  'organization-detail': 'Organisation',
  'organization-activities': 'Aktivitäten',
  'organization-management': 'Verwaltung',
  'organization-members': 'Mitglieder',
  'organization-posts': 'Alle Funks',
  'organization-posts-with-activities': 'Mitgefunkt',
  'organization-create': 'Organisation erstellen',
  'organization-edit': 'Organisation bearbeiten',
  'organization-area': 'Organisationen',
  'statistics-email': 'Statistiken'
};

const sharedEN = {
  'profile-edit': 'Edit Profile',
  chats: 'Private messages',
  'my-posts': 'My Posts',
  participated: 'Participated',
  'notification-setting': 'Notifications & Channels',
  'app-setting': 'Display & Language',
  'geo-area-subscription': 'Home town & surrounding area',
  help: 'Help',
  'first-steps': 'First Steps',
  'invite-friend': 'Invite Friends to the app',
  legal: 'Legal Information',
  'change-password': 'Change Password',
  'request-data': 'Request Data Report',
  'delete-account': 'Delete Account',
  experiments: 'Developer',
  'organization-overview': 'Organizations',
  'organization-detail': 'Organization',
  'organization-activities': 'Activities',
  'organization-management': 'Management',
  'organization-members': 'Members',
  'organization-posts': 'All posts',
  'organization-posts-with-activities': 'Participated',
  'organization-create': 'Create organization',
  'organization-edit': 'Edit organization',
  'organization-area': 'Organizations',
  'statistics-email': 'Statistics'
};
export const profileSettingsGermanLocalization = {
  routes: sharedDE,
  screens: {
    'profile-setting': {
      public: 'Dein öffentlicher Name:',
      edit: 'Profil bearbeiten',
      contact: 'Kontaktaufnahmen',
      organizations: 'Organisationen',
      settings: 'Einstellungen',
      more: 'Mehr',
      account: 'Konto',
      ...sharedDE,
      globalLogout: 'Von allen Geräten abmelden',
      globalLogoutIn:
        'Du wirst innerhalb der nächsten {{duration}} Minuten von anderen Geräten ausgeloggt.',
      logout: 'Abmelden',
      version: 'Version: {{version}}',
      unknown: 'unbekannt',
      myRadius: 'Meine Region & Radius',
      myRadiusDescription: 'Radius {{km}} km',
      share: {
        title: 'Freunde zu {{appName}} einladen',
        message:
          'Ich bin jetzt bei {{appName}} – spannende Idee, um mit der Nachbarschaft vernetzt zu bleiben. Schau mal rein:',
        note: 'Der folgende Text wurde in deine Zwischenablage kopiert:'
      },
      state: {
        loading: { title: 'Profil wird geladen' },
        error: {
          title: 'Profil konnte nicht geladen werden',
          subtitle: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
        }
      },
      alerts: {
        'request-data': {
          title: 'Daten anfordern',
          content:
            'Lass dir innerhalb von 48 Stunden eine Kopie deiner Daten per E-Mail an {{email}} zuschicken.',
          confirm: 'Anfordern',
          cancel: 'Abbrechen'
        }
      }
    },
    'app-setting': {
      appearance: 'Darstellung',
      auto: 'Automatisch (Geräteeinstellungen)',
      light: 'Hell',
      dark: 'Dunkel',
      language: 'Sprache',
      de: 'Deutsch',
      en: 'English',
      translated: {
        de: 'Deutsch',
        en: 'Englisch'
      }
    },
    'notification-setting': {
      channels: 'Abonnierte Kanäle',
      notifications: 'Benachrichtigungen',
      posts: 'Für neue Funks',
      groups: 'Für Gruppen',
      miscellaneous: 'Sonstige',
      organizations: 'Organisationen',
      commentPushNotifications: 'Kommentar-Benachrichtigungen',
      state: {
        loading: { title: 'Einstellungen werden geladen' },
        error: {
          title: 'Einstellungen konnten nicht geladen werden',
          subtitle: 'Bitte versuche es zu einem späteren Zeitpunkt erneut.'
        }
      }
    },
    chats: {
      title: 'Private Nachrichten',
      archive: 'Archiv',
      empty:
        'Keine privaten Nachrichten. Sende welche über „Privat schreiben“ in der Funkzentrale.'
    },
    'organization-overview': {
      areas: 'Gebiete',
      organizations: 'Organisationen',
      empty: 'Keine Organisationen gefunden.',
      create: 'Neue Organisation erstellen',
      state: {
        loading: { title: 'Organisationen werden geladen' },
        error: {
          title: 'Organisationen konnten nicht geladen werden',
          subtitle: 'Bitte versuche es später erneut.'
        }
      }
    },
    'organization-activities': {
      title: 'Aktivitäten',
      'all-posts': 'Alle Funks',
      mentioned: 'Mir gefunkt'
    },
    'organization-management': {
      title: 'Verwaltung',
      members: 'Mitglieder',
      statistics: 'Statistiken per E-Mail'
    },
    'statistics-email': {
      title: 'Statistiken',
      heading: 'Statistiken per E-Mail',
      description:
        'Die Statistiken werden je nach gewählter Häufigkeit automatisch <bold>per E-Mail an alle Admins</bold> gefunkt.',
      options: {
        off: 'Aus',
        weekly: 'Wöchentlich',
        monthly: 'Monatlich'
      },
      rowLabels: {
        off: 'Aus',
        weekly: 'Wöchentlich',
        monthly: 'Monatlich'
      },
      state: {
        loading: { title: 'Einstellungen werden geladen' },
        error: {
          title: 'Einstellungen konnten nicht geladen werden',
          subtitle: 'Bitte versuche es später erneut.'
        },
        noAccess: {
          title: 'Kein Zugriff',
          subtitle: 'Du hast keine Berechtigung, diese Einstellungen zu ändern.'
        }
      },
      updateError: 'Einstellung konnte nicht gespeichert werden.'
    },
    organization: {
      label: 'Organisation',
      geoAreaPicker: {
        title: 'Ort wählen',
        selectArea: 'Ort auswählen',
        selectedCount: '{{count}} Gebiete ausgewählt',
        selectionOf: '{{selected}} von {{total}}',
        allAreasLabel: 'Alle Gebiete',
        wholeArea: 'Ganz {{area}}',
        wholeAreaDescription: 'Umfasst alle Untergebiete',
        subAreas: 'Untergebiete',
        selectAll: 'Alle auswählen',
        deselectAll: 'Alle abwählen',
        back: 'Zurück',
        confirm: '{{count}} Gebiete übernehmen',
        loading: 'Gebiete werden geladen',
        empty: 'Keine Untergebiete verfügbar'
      }
    },
    'organization-members': {
      title: 'Mitglieder',
      sections: {
        admins_one: 'Chef Funker ({{count}})',
        admins_other: 'Chef Funker ({{count}})',
        funkers_one: 'Funker ({{count}})',
        funkers_other: 'Funker ({{count}})'
      },
      sectionDescriptions: {
        admins: 'Verwalten Organisation, Mitglieder & Inhalte',
        funkers: 'Erstellen & verwalten Inhalte'
      },
      buttons: {
        addMember: 'Mitglied hinzufügen',
        memberActions: 'Aktionen'
      },
      row: {
        changeRole: 'Rolle ändern',
        writePrivate: 'Privat schreiben',
        removeFromOrg: 'Aus Organisation entfernen',
        leaveOrg: 'Organisation verlassen'
      },
      changeRoleSheet: {
        title: 'Rolle ändern',
        description:
          'Lege fest, welche Rolle <bold>{{name}}</bold> in der Organisation hat.',
        cancel: 'Abbrechen',
        apply: 'Übernehmen'
      },
      alerts: {
        removeMember: {
          title: '{{name}} entfernen?',
          content:
            '{{name}} hat danach keinen Zugriff mehr auf die Organisation. Beiträge und Kommentare bleiben weiterhin sichtbar.',
          confirm: 'Entfernen',
          cancel: 'Abbrechen'
        },
        leaveOrganization: {
          title: 'Organisation verlassen?',
          content:
            'Du verlässt die Organisation und hast danach keinen Zugriff mehr auf Inhalte und Funktionen. Deine bisherigen Inhalte bleiben erhalten.',
          confirm: 'Verlassen',
          cancel: 'Abbrechen'
        },
        lastAdmin: {
          title: 'Nicht möglich',
          content:
            'Der letzte Admin kann nicht entfernt oder herabgestuft werden.',
          confirm: 'OK'
        },
        cannotLeaveLastAdmin: {
          title: 'Verlassen nicht möglich',
          content: 'Es muss mindestens eine Person mit Admin-Rechten geben.',
          confirm: 'Alles klar'
        },
        cannotRemoveLastAdmin: {
          title: 'Entfernen nicht möglich',
          content: 'Es muss mindestens eine Person mit Admin-Rechten geben.',
          confirm: 'Alles klar'
        },
        cannotDemoteLastAdmin: {
          title: 'Rolle ändern nicht möglich',
          content: 'Es muss mindestens eine Person mit Admin-Rechten geben.',
          confirm: 'Alles klar'
        },
        actionFailed: {
          title: 'Aktion fehlgeschlagen',
          content: 'Bitte versuche es später erneut.',
          confirm: 'OK'
        }
      },
      state: {
        loading: { title: 'Mitglieder werden geladen' },
        error: {
          title: 'Mitglieder konnten nicht geladen werden',
          subtitle: 'Bitte versuche es später erneut.'
        }
      },
      add: {
        title: 'Mitglied hinzufügen',
        description:
          'Gib die E-Mail-Adresse eines bestehenden Nutzers ein und füge die Person hinzu.',
        emailLabel: 'E-Mail',
        emailHint:
          'Nur <bold>bestehende Nutzer</bold> können hinzugefügt werden',
        emailChecking: 'E-Mail wird überprüft …',
        errors: {
          emailRequired: 'E-Mail-Adresse ist erforderlich',
          emailInvalid: 'Ungültige E-Mail-Adresse',
          emailNotFound: 'Kein bestehender Nutzer mit dieser E-Mail gefunden',
          emailNotVerified: 'Diese E-Mail ist noch nicht verifiziert',
          roleAlreadyAssigned:
            'Dieser Nutzer hat diese Rolle bereits in der Organisation',
          generic: 'Mitglied konnte nicht hinzugefügt werden'
        },
        roleSection: 'Rolle wählen',
        roleAdminDescription: 'Kann die Organisation & Inhalte verwalten',
        roleFunkerDescription: 'Kann Inhalte erstellen & verwalten',
        cta: 'Mitglied hinzufügen'
      }
    },
    'organization-create': {
      title: 'Organisation erstellen',
      description:
        'Lege Name, Typ und Gebiete fest und\nfüge optional ein Logo hinzu',
      steps: {
        organizationData: 'Organisation erstellen',
        adminSetup: 'Admin festlegen',
        adminSubtitle: 'Lege fest, wer die Organisation\n zunächst verwaltet.',
        whoIsAdmin: 'Wer wird Admin?',
        selfOption: 'Ich selbst',
        otherPersonOption: 'Eine andere Person',
        emailHelp: 'Person über E-Mail-Adresse hinzufügen.',
        emailChecking: 'E-Mail wird überprüft …',
        registeredUsersHintPrefix: 'Nur ',
        registeredUsersHintBold: 'bestehende Nutzer',
        registeredUsersHintSuffix: ' können hinzugefügt werden.'
      },
      fields: {
        name: 'Name',
        tags: 'Typen',
        adminEmail: 'Admin E-Mail',
        geoArea: 'Gebiete',
        geoAreaHelper: 'Bestimmt, wo die Organisation veröffentlichen kann.',
        mayorGreeting: 'Grußwort'
      },
      placeholders: {
        tags: 'Typ auswählen',
        tagsLoading: 'Typen werden geladen …',
        adminEmail: 'admin@beispiel.de',
        mayorGreeting:
          'Schreibe hier dein Grußwort an die Bürgerinnen und Bürger.'
      },
      actions: {
        save: 'Erstellen',
        cancel: 'Abbrechen',
        next: 'Weiter'
      },
      toasts: {
        created: '{{name}} erstellt'
      },
      errors: {
        nameRequired: 'Name ist erforderlich',
        tagsRequired: 'Wähle einen Organisationstyp aus.',
        adminEmailRequired: 'Admin-E-Mail ist erforderlich',
        adminEmailInvalid: 'Bitte gib eine gültige E-Mail Adresse ein',
        adminEmailNotFound:
          'Kein bestehender Nutzer mit dieser E-Mail gefunden',
        adminEmailNotVerified: 'Diese E-Mail ist noch nicht verifiziert',
        geoAreaRequired: 'Gebiet ist erforderlich',
        mayorGreetingTooLong:
          'Das Grußwort darf höchstens {{max}} Zeichen lang sein.'
      }
    },
    'organization-edit': {
      title: 'Organisation bearbeiten',
      description: 'Bearbeite das Profil deiner Organisation.',
      territorialAuthorityTitle: 'Kommune bearbeiten',
      territorialAuthorityDescription:
        'Bearbeite das Profil und die Inhalte deiner Kommune unter „{{region}}“.',
      sections: {
        contact: 'Kontakt',
        infoAndContact: 'Infos & Kontakt',
        images: 'Bilder ({{count}}/{{max}})',
        description: 'Beschreibung',
        facts: 'Zahlen & Fakten ({{count}}/{{max}})',
        factsDescription:
          'Ergänze kurze Fakten über die Organisation.\nZum Beispiel: Gründung 1898'
      },
      fields: {
        name: 'Name (Pflichtfeld)',
        address: 'Adresse',
        url: 'Web',
        phone: 'Telefon',
        emailAddress: 'E-Mail',
        description: 'Beschreibung',
        factName: 'Bezeichnung',
        factValue: 'Wert',
        population: 'Einwohnende',
        areaSquareKm: 'Fläche (km²)',
        mayorGreeting: 'Grußwort',
        imageLabel: 'Bild {{index}} von {{total}}'
      },
      placeholders: {
        name: 'Name der Organisation',
        address: 'Adresse',
        url: 'www.beispiel.de',
        phone: '+49 123 456789',
        emailAddress: 'info@beispiel.de',
        description:
          'Beschreibe deine Organisation, z. B. Aktivitäten oder Besonderheiten.',
        descriptionTerritorialAuthority:
          'Beschreibe deine Kommune, z. B. Lage oder Besonderheiten.',
        factName: 'z. B. Gründung',
        factValue: 'z. B. 1898',
        population: 'z. B. 12.345',
        areaSquareKm: 'z. B. 45,6',
        mayorGreeting:
          'Schreibe hier dein Grußwort an die Bürgerinnen und Bürger.'
      },
      actions: {
        save: 'Übernehmen',
        cancel: 'Abbrechen',
        preview: 'Vorschau anzeigen',
        more: 'Mehr',
        delete: 'Organisation löschen',
        addImage: 'Bild hinzufügen',
        removeImage: 'Bild entfernen',
        removeImageWithIndex: 'Bild {{index}} entfernen',
        addFact: 'Fakt hinzufügen',
        removeFact: 'Fakt entfernen'
      },
      errors: {
        nameRequired: 'Bitte gib den Namen der Organisation ein.',
        emailAddressInvalid:
          'Bitte gib eine gültige E-Mail ein (z. B. beispiel@domain.de).',
        phoneInvalid: 'Bitte gib eine gültige Telefonnummer ein.',
        urlInvalid: 'Bitte gib eine gültige Webadresse ein.',
        factIncomplete: 'Beide Felder sind erforderlich',
        descriptionTooLong:
          'Die Beschreibung darf höchstens {{max}} Zeichen lang sein.',
        populationInvalid: 'Bitte gib eine gültige Zahl ein.',
        areaSquareKmInvalid: 'Bitte gib eine gültige Zahl ein.',
        mayorGreetingTooLong:
          'Das Grußwort darf höchstens {{max}} Zeichen lang sein.',
        imageTooLarge: 'Das Bild ist zu groß (max. 10 MB).',
        imageUploadFailed:
          'Das Bild konnte nicht hochgeladen werden. Bitte entferne es und versuche es erneut.',
        imageErrorWithIndex: 'Bild {{index}}: {{message}}'
      },
      warnings: {
        imageAspectRatio:
          'Quadratische Bilder werden in der App am besten dargestellt.'
      },
      descriptionEditor: {
        title: 'Beschreibung',
        placeholder:
          'Beschreibe deine Organisation, z. B. Aktivitäten oder Besonderheiten.',
        counter: '{{count}}/{{max}}',
        close: 'Schließen',
        confirm: 'Übernehmen'
      },
      mayorGreetingEditor: {
        title: 'Grußwort',
        placeholder:
          'Schreibe hier dein Grußwort an die Bürgerinnen und Bürger.'
      },
      preview: {
        title: 'Vorschau: Darstellung in „{{region}}"',
        titleFallback: 'Vorschau',
        close: 'Schließen',
        about: 'Über uns',
        facts: 'In Zahlen',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        rows: {
          population: 'Einwohnende',
          areaSquareKm: 'Fläche',
          url: 'Web'
        },
        formats: {
          areaSquareKm: '{{value}} km²'
        }
      },
      alerts: {
        'confirm-delete': {
          title: 'Organisation löschen?',
          content:
            'Die Organisation wird nicht mehr angezeigt und kann nicht mehr genutzt werden. Mitglieder haben danach keinen Zugriff mehr auf Inhalte und Funktionen der Organisation. Bisherige Inhalte bleiben erhalten.',
          confirm: 'Löschen',
          cancel: 'Abbrechen'
        }
      },
      state: {
        loading: { title: 'Organisation wird geladen' },
        error: {
          title: 'Organisation konnte nicht geladen werden',
          subtitle: 'Bitte versuche es zu einem späteren Zeitpunkt erneut.'
        },
        noAccess: {
          title: 'Kein Zugriff',
          subtitle:
            'Du hast keine Berechtigung, diese Organisation zu bearbeiten.'
        }
      },
      accessibility: {
        fieldHint: 'Text eingeben und bearbeiten'
      }
    },
    'organization-area': {
      title_one: '{{count}} Organisation im Gebiet',
      title_other: '{{count}} Organisationen im Gebiet',
      areas: 'Gebiete',
      empty: 'Keine Organisationen in diesem Gebiet.',
      emptyFiltered:
        'Für die ausgewählten Filter wurden keine Organisationen gefunden.',
      resetFilters: 'Filter zurücksetzen',
      emptyArea:
        'In diesem Gebiet gibt es noch keine Organisationen. Erstelle eine Organisation, damit sie eigene Inhalte veröffentlichen kann.',
      createOrganization: 'Organisation erstellen',
      create: 'Neue Organisation erstellen',
      filters: {
        tagsLabel: 'Art',
        tagsPlaceholder: 'Alle Typen',
        tagsSelectedCount_one: '{{count}} Typ',
        tagsSelectedCount_other: '{{count}} Typen',
        tagsSheetTitle: 'Typen auswählen',
        geoAreaLabel: 'Gebiete',
        geoAreaPlaceholder: 'Alle Gebiete',
        geoAreaSelectedCount_one: '{{count}} Gebiet',
        geoAreaSelectedCount_other: '{{count}} Gebiete',
        geoAreaSheetTitle: 'Ort auswählen',
        confirm_zero: 'Anwenden',
        confirm_one: 'Anwenden ({{count}})',
        confirm_other: 'Anwenden ({{count}})'
      },
      state: {
        loading: { title: 'Organisationen werden geladen' },
        error: {
          title: 'Organisationen konnten nicht geladen werden',
          subtitle: 'Bitte versuche es später erneut.'
        }
      }
    }
  },
  components: {
    'profile-editor': {
      header: {
        registration: 'Dein Profil',
        edit: 'Profil bearbeiten',
        description:
          'Sag hallo mit echtem Namen –\n so entsteht Vertrauen in deiner Region.'
      },
      firstName: 'Vorname',
      lastName: 'Nachname',
      public: 'So sehen dich andere:',
      birthYear: 'Geburtsjahr',
      birthInfo: 'Dein Geburtsjahr wird nicht öffentlich angezeigt.',
      birthError: {
        undefined: 'Dein Geburtsjahr darf nicht leer sein.',
        young: 'Tut uns leid! Unsere App ist erst ab 16 Jahren.',
        old: 'Dein Geburtsjahr darf nicht vor 1900 sein.'
      },
      nameError: {
        short: `Der Name ist zu kurz. Er muss mindestens ${MIN_NAME_LENGTH} Zeichen lang sei.`,
        wrongCharacters:
          'Ungültiger Name: Der Name muss mit einem Buchstaben beginnen und darf nur Buchstaben, Zahlen, Punkte (.), Bindestriche (-) oder Leerzeichen enthalten.'
      },
      email: 'E-Mail-Adresse',
      notVerified: 'Noch nicht bestätigt.',
      alerts: {
        change: {
          title: '{{field}} anpassen?',
          content:
            'Bitte kontaktiere unser Supportteam, um deine {{field}} anzupassen.',
          confirm: 'Kontakt aufnehmen',
          cancel: 'Abbrechen'
        }
      },
      next: 'Weiter',
      save: 'Übernehmen',
      menu: {
        select: 'Aus Bibliothek auswählen',
        take: 'Foto aufnehmen',
        delete: 'Löschen'
      }
    },
    chatListItem: {
      personBlocked: 'Du hast diese Person blockiert',
      accountDeleted: 'Gelöschtes Konto',
      messageDeleted: 'Nachricht gelöscht'
    },
    'organization-search': {
      placeholder: 'Suche nach Organisationen im Gebiet',
      hint: 'Gib min. {{count}} Buchstaben ein...',
      empty:
        'Keine Organisation gefunden. Prüfe den Suchbegriff oder erstelle eine neue Organisation.',
      createCta: 'Organisation erstellen?'
    }
  }
};

// Todo: Define exact type so that english does not include unnecessary keys
// Guarantees that both translations have the same structure
type ProfileSettingLocalization = typeof profileSettingsGermanLocalization;

export const profileSettingsEnglishLocalization: ProfileSettingLocalization = {
  routes: sharedEN,
  screens: {
    'profile-setting': {
      public: 'Your publicly name:',
      edit: 'Edit Profile',
      contact: 'Contact',
      organizations: 'Organizations',
      settings: 'Settings',
      more: 'More',
      account: 'Account',
      ...sharedEN,
      globalLogout: 'Log out from all devices',
      globalLogoutIn:
        'You will be logged out from other devices with the next {{duration}} minutes.',
      logout: 'Logout',
      version: 'Version: {{version}}',
      unknown: 'unknown',
      myRadius: 'My Region & Radius',
      myRadiusDescription: 'Radius {{km}} km',
      share: {
        title: 'Invite friends to {{appName}}',
        message:
          "I'm now on {{appName}} – an exciting idea to stay connected with the neighborhood. Check it out:",
        note: 'The following text has been copied to your clipboard:'
      },
      state: {
        loading: { title: 'Profile is loading' },
        error: {
          title: 'Profile could not be loaded',
          subtitle: 'Please try again later.'
        }
      },
      alerts: {
        'request-data': {
          title: 'Request Data',
          content:
            'Request a copy of your data to be sent to {{email}} within 48 hours.',
          confirm: 'Request',
          cancel: 'Cancel'
        }
      }
    },
    'app-setting': {
      appearance: 'Appearance',
      auto: 'Automatic (Device Settings)',
      light: 'Light',
      dark: 'Dark',
      language: 'Language',
      de: 'Deutsch',
      en: 'English',
      translated: {
        de: 'German',
        en: 'English'
      }
    },
    'notification-setting': {
      channels: 'Subscribed channels',
      notifications: 'Notifications',
      posts: 'For new posts',
      groups: 'For groups',
      miscellaneous: 'Miscellaneous',
      organizations: 'Organizations',
      commentPushNotifications: 'Comment notifications',
      state: {
        loading: { title: 'Settings are loading' },
        error: {
          title: 'Settings could not be loaded',
          subtitle: 'Please try again later.'
        }
      }
    },
    chats: {
      title: 'Private messages',
      archive: 'Archive',
      empty:
        'No private messages. Send some via "Write privately" in the Local Hub.'
    },
    'organization-overview': {
      areas: 'Areas',
      organizations: 'Organizations',
      empty: 'No organizations found.',
      create: 'Create new organization',
      state: {
        loading: { title: 'Loading organizations' },
        error: {
          title: 'Could not load organizations',
          subtitle: 'Please try again later.'
        }
      }
    },
    'organization-activities': {
      title: 'Activities',
      'all-posts': 'All posts',
      mentioned: 'Mentioned me'
    },
    'organization-management': {
      title: 'Management',
      members: 'Members',
      statistics: 'Statistics via email'
    },
    'statistics-email': {
      title: 'Statistics',
      heading: 'Statistics via email',
      description:
        'Depending on the chosen frequency the statistics are automatically <bold>sent by email to all admins</bold>.',
      options: {
        off: 'Off',
        weekly: 'Weekly',
        monthly: 'Monthly'
      },
      rowLabels: {
        off: 'Off',
        weekly: 'Weekly',
        monthly: 'Monthly'
      },
      state: {
        loading: { title: 'Loading settings' },
        error: {
          title: 'Could not load settings',
          subtitle: 'Please try again later.'
        },
        noAccess: {
          title: 'No access',
          subtitle: 'You do not have permission to change these settings.'
        }
      },
      updateError: 'Could not save setting.'
    },
    'organization-members': {
      title: 'Members',
      sections: {
        admins_one: 'Chief Funker ({{count}})',
        admins_other: 'Chief Funkers ({{count}})',
        funkers_one: 'Funker ({{count}})',
        funkers_other: 'Funkers ({{count}})'
      },
      sectionDescriptions: {
        admins: 'Manage organization, members & content',
        funkers: 'Create & manage content'
      },
      buttons: {
        addMember: 'Add member',
        memberActions: 'Actions'
      },
      row: {
        changeRole: 'Change role',
        writePrivate: 'Send private message',
        removeFromOrg: 'Remove from organization',
        leaveOrg: 'Leave organization'
      },
      changeRoleSheet: {
        title: 'Change role',
        description:
          'Choose which role <bold>{{name}}</bold> has in the organization.',
        cancel: 'Cancel',
        apply: 'Apply'
      },
      alerts: {
        removeMember: {
          title: 'Remove {{name}}?',
          content:
            '{{name}} will no longer have access to the organization. Posts and comments remain visible.',
          confirm: 'Remove',
          cancel: 'Cancel'
        },
        leaveOrganization: {
          title: 'Leave organization?',
          content:
            'You will leave the organization and no longer have access to its content and functions. Your existing content will be retained.',
          confirm: 'Leave',
          cancel: 'Cancel'
        },
        lastAdmin: {
          title: 'Not possible',
          content: 'The last admin cannot be removed or demoted.',
          confirm: 'OK'
        },
        cannotLeaveLastAdmin: {
          title: 'Cannot leave',
          content: 'There must be at least one person with admin rights.',
          confirm: 'Got it'
        },
        cannotRemoveLastAdmin: {
          title: 'Cannot remove',
          content: 'There must be at least one person with admin rights.',
          confirm: 'Got it'
        },
        cannotDemoteLastAdmin: {
          title: 'Cannot change role',
          content: 'There must be at least one person with admin rights.',
          confirm: 'Got it'
        },
        actionFailed: {
          title: 'Action failed',
          content: 'Please try again later.',
          confirm: 'OK'
        }
      },
      state: {
        loading: { title: 'Loading members' },
        error: {
          title: 'Could not load members',
          subtitle: 'Please try again later.'
        }
      },
      add: {
        title: 'Add member',
        description:
          'Enter the email address of an existing user and add them.',
        emailLabel: 'Email',
        emailHint: 'Only <bold>existing users</bold> can be added',
        emailChecking: 'Checking email …',
        errors: {
          emailRequired: 'Email address is required',
          emailInvalid: 'Invalid email address',
          emailNotFound: 'No existing user found with this email',
          emailNotVerified: 'This email is not yet verified',
          roleAlreadyAssigned:
            'This user already has this role in the organization',
          generic: 'Could not add member'
        },
        roleSection: 'Select role',
        roleAdminDescription: 'Can manage the organization & content',
        roleFunkerDescription: 'Can create & manage content',
        cta: 'Add member'
      }
    },
    organization: {
      label: 'Organization',
      geoAreaPicker: {
        title: 'Select area',
        selectArea: 'Select area',
        selectedCount: '{{count}} areas selected',
        selectionOf: '{{selected}} of {{total}}',
        allAreasLabel: 'All areas',
        wholeArea: 'Entire {{area}}',
        wholeAreaDescription: 'Includes all sub-areas',
        subAreas: 'Sub-areas',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        back: 'Back',
        confirm: 'Confirm {{count}} areas',
        loading: 'Loading areas',
        empty: 'No sub-areas available'
      }
    },
    'organization-create': {
      title: 'Create Organization',
      description: 'Set name, type and area\nand add a logo optionally',
      steps: {
        organizationData: 'Create organization',
        adminSetup: 'Set admin',
        adminSubtitle: 'Set who will initially\n manage the organization.',
        whoIsAdmin: 'Who will be the admin?',
        selfOption: 'Myself',
        otherPersonOption: 'Another person',
        emailHelp: 'Add person via email address.',
        emailChecking: 'Checking email …',
        registeredUsersHintPrefix: 'Only ',
        registeredUsersHintBold: 'existing users',
        registeredUsersHintSuffix: ' can be added.'
      },
      fields: {
        name: 'Name',
        tags: 'Types',
        adminEmail: 'Admin email',
        geoArea: 'Area',
        geoAreaHelper: 'Determines where the organization can publish.',
        mayorGreeting: 'Greeting'
      },
      placeholders: {
        tags: 'Select type',
        tagsLoading: 'Loading types …',
        adminEmail: 'admin@example.com',
        mayorGreeting: 'Write your greeting to the citizens here.'
      },
      actions: {
        save: 'Create',
        cancel: 'Cancel',
        next: 'Next'
      },
      toasts: {
        created: '{{name}} created'
      },
      errors: {
        nameRequired: 'Name is required',
        tagsRequired: 'Select an organization type.',
        adminEmailRequired: 'Admin email is required',
        adminEmailInvalid: 'Please enter a valid email address',
        adminEmailNotFound: 'No existing user found with this email',
        adminEmailNotVerified: 'This email is not yet verified',
        geoAreaRequired: 'Area is required',
        mayorGreetingTooLong:
          'The greeting may be at most {{max}} characters long.'
      }
    },
    'organization-edit': {
      title: 'Edit organisation',
      description: 'Edit your organisation profile.',
      territorialAuthorityTitle: 'Edit community',
      territorialAuthorityDescription:
        'Edit the profile and content of your community under "{{region}}".',
      sections: {
        contact: 'Contact',
        infoAndContact: 'Info & contact',
        images: 'Images ({{count}}/{{max}})',
        description: 'Description',
        facts: 'Facts & Figures ({{count}}/{{max}})',
        factsDescription:
          'Add short facts about the organisation.\nFor example: Founded 1898'
      },
      fields: {
        name: 'Name (Required)',
        address: 'Address',
        url: 'Web',
        phone: 'Phone',
        emailAddress: 'Email',
        description: 'Description',
        factName: 'Label',
        factValue: 'Value',
        population: 'Inhabitants',
        areaSquareKm: 'Area (km²)',
        mayorGreeting: 'Greeting',
        imageLabel: 'Image {{index}} of {{total}}'
      },
      placeholders: {
        name: 'Organisation name',
        address: 'Address',
        url: 'www.example.com',
        phone: '+49 123 456789',
        emailAddress: 'info@example.com',
        description:
          'Describe your organisation, e.g. activities or special features.',
        descriptionTerritorialAuthority:
          'Describe your community, e.g. location or special features.',
        factName: 'e.g. Founded',
        factValue: 'e.g. 1898',
        population: 'e.g. 12,345',
        areaSquareKm: 'e.g. 45.6',
        mayorGreeting: 'Write your greeting to the citizens here.'
      },
      actions: {
        save: 'Apply',
        cancel: 'Cancel',
        preview: 'Show preview',
        more: 'More',
        delete: 'Delete organization',
        addImage: 'Add image',
        removeImage: 'Remove image',
        removeImageWithIndex: 'Remove image {{index}}',
        addFact: 'Add fact',
        removeFact: 'Remove fact'
      },
      errors: {
        nameRequired: 'Please enter the name of the organisation.',
        emailAddressInvalid:
          'Please enter a valid email address (e.g. example@domain.com).',
        phoneInvalid: 'Please enter a valid phone number.',
        urlInvalid: 'Please enter a valid web address.',
        factIncomplete: 'Both fields are required',
        descriptionTooLong:
          'The description may be at most {{max}} characters long.',
        populationInvalid: 'Please enter a valid number.',
        areaSquareKmInvalid: 'Please enter a valid number.',
        mayorGreetingTooLong:
          'The greeting may be at most {{max}} characters long.',
        imageTooLarge: 'The image is too large (max. 10 MB).',
        imageUploadFailed:
          'The image could not be uploaded. Please remove it and try again.',
        imageErrorWithIndex: 'Image {{index}}: {{message}}'
      },
      warnings: {
        imageAspectRatio: 'Square images display best in the app.'
      },
      descriptionEditor: {
        title: 'Description',
        placeholder:
          'Describe your organisation, e.g. activities or special features.',
        counter: '{{count}}/{{max}}',
        close: 'Close',
        confirm: 'Apply'
      },
      mayorGreetingEditor: {
        title: 'Greeting',
        placeholder: 'Write your greeting to the citizens here.'
      },
      preview: {
        title: 'Preview: appearance in "{{region}}"',
        titleFallback: 'Preview',
        close: 'Close',
        about: 'About us',
        facts: 'In numbers',
        showMore: 'Show more',
        showLess: 'Show less',
        rows: {
          population: 'Inhabitants',
          areaSquareKm: 'Area',
          url: 'Web'
        },
        formats: {
          areaSquareKm: '{{value}} km²'
        }
      },
      alerts: {
        'confirm-delete': {
          title: 'Delete organization?',
          content:
            'The organization will no longer be displayed and can no longer be used. Members will no longer have access to its content and functions afterwards. Existing content will be retained.',
          confirm: 'Delete',
          cancel: 'Cancel'
        }
      },
      state: {
        loading: { title: 'Loading organization' },
        error: {
          title: 'Could not load organization',
          subtitle: 'Please try again later.'
        },
        noAccess: {
          title: 'No access',
          subtitle: 'You do not have permission to edit this organization.'
        }
      },
      accessibility: {
        fieldHint: 'Enter and edit text'
      }
    },
    'organization-area': {
      title_one: '{{count}} organization in area',
      title_other: '{{count}} organizations in area',
      areas: 'Areas',
      empty: 'No organizations in this area.',
      emptyFiltered: 'No organizations were found for the selected filters.',
      resetFilters: 'Reset filters',
      emptyArea:
        'There are no organizations in this area yet. Create an organization so it can publish its own content.',
      createOrganization: 'Create organization',
      create: 'Create new organization',
      filters: {
        tagsLabel: 'Type',
        tagsPlaceholder: 'All types',
        tagsSelectedCount_one: '{{count}} type',
        tagsSelectedCount_other: '{{count}} types',
        tagsSheetTitle: 'Select types',
        geoAreaLabel: 'Area',
        geoAreaPlaceholder: 'All areas',
        geoAreaSelectedCount_one: '{{count}} area',
        geoAreaSelectedCount_other: '{{count}} areas',
        geoAreaSheetTitle: 'Select area',
        confirm_zero: 'Apply',
        confirm_one: 'Apply ({{count}})',
        confirm_other: 'Apply ({{count}})'
      },
      state: {
        loading: { title: 'Loading organizations' },
        error: {
          title: 'Could not load organizations',
          subtitle: 'Please try again later.'
        }
      }
    }
  },
  components: {
    'profile-editor': {
      header: {
        registration: 'Your Profile',
        edit: 'Edit profile',
        description:
          'Say hello with your real name –\n this builds trust in your area.'
      },
      firstName: 'First Name',
      lastName: 'Last Name',
      public: 'This is how others see you:',
      birthYear: 'Birth Year',
      birthInfo: 'Your birth year will not be publicly displayed.',
      birthError: {
        undefined: 'Your birth year cannot be empty',
        young: 'Sorry! Our app is only for ages 16 and up.',
        old: 'Your birth year cannot be before 1900'
      },
      nameError: {
        short: `The name is too short. It must be at least ${MIN_NAME_LENGTH} characters long.`,
        wrongCharacters:
          'Invalid name: The name must start with a letter and may only contain letters, numbers, dots (.), hyphens (-), or spaces.'
      },
      email: 'Email Address',
      notVerified: 'Not yet confirmed.',
      alerts: {
        change: {
          title: 'Adjust {{field}}?',
          content: 'Please contact our support team to adjust your {{field}}.',
          confirm: 'Contact Us',
          cancel: 'Cancel'
        }
      },
      next: 'Next',
      save: 'Save',
      menu: {
        select: 'Select from library',
        take: 'Take a photo',
        delete: 'Delete'
      }
    },
    chatListItem: {
      personBlocked: 'You have blocked this person',
      accountDeleted: 'Deleted account',
      messageDeleted: 'Message deleted'
    },
    'organization-search': {
      placeholder: 'Search for organizations in area',
      hint: 'Enter at least {{count}} letters...',
      empty:
        'No organization found. Check your search term or create a new organization.',
      createCta: 'Create organization?'
    }
  }
};
